<template>
  <div id="spinner" v-bind:class="{ loading: isLoading }">
    <div class="loader">
      <div class="loader">
          <div class="loader">
             <div class="loader">
             </div>
          </div>
      </div>
    </div>
  </div><!-- spinner -->
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Spinner',
    computed: {
      ...mapGetters([
        'isLoading'
      ])
    }
  }
</script>
